<template>
    <div class="audio-record" :class="[type]">
        <m-audio :src="src"></m-audio>
    </div>
</template>
<script>
export default {
    props: {
        src: {
            type: String
        },
        type: {
            type: String,
            default() { return 'left' },
            validator: s => ['left', 'right'].includes(s)
        }
    },
}
</script>
<style lang="scss" scoped>
::v-deep.audio-record {
    padding: 7px 10px;
    border-radius: 6px;
    background: white;
    position: relative;
    margin-top: 5px;
    .x-audio-wrap {
        height: 20px;
        box-shadow: none;
    }
    &.left {
        @-webkit-keyframes play-dot {
            0% {
            background:#5cadff;
            }
            to {
            background:#999;
            }
        }
        @keyframes play-dot {
            0% {
            background:#5cadff;
            }
            to {
            background:#999;
            }
        }
        @-webkit-keyframes play-sector {
            0% {
            border-color:#5cadff;
            }
            to{
            border-color:#999;
            }
        }
        @keyframes play-sector {
            0% {
            border-color:#5cadff;
            }
            to {
            border-color:#999;
            }
        }
        .x-sector {
            border-right: 2px solid #5cadff;
            border-top: 2px solid #5cadff;
            .x-dot {
                background: #5cadff;
            }
        }
        .x-sector::before {
            border-right: 2px solid #5cadff;
            border-top: 2px solid #5cadff;
        }
        .x-sector::after {
            border-right: 2px solid #5cadff;
            border-top: 2px solid #5cadff;
        }
    }
    &.right {
        background: #4996F6;
        margin-right: 10px;
        @-webkit-keyframes play-dot {
            0% {
            background:white;
            }
            to {
            background:#1D61B5;
            }
        }
        @keyframes play-dot {
            0% {
            background:white;
            }
            to {
            background:#1D61B5;
            }
        }
        @-webkit-keyframes play-sector {
            0% {
            border-color:white;
            }
            to{
            border-color:#1D61B5;
            }
        }
        @keyframes play-sector {
            0% {
            border-color:white;
            }
            to {
            border-color:#1D61B5;
            }
        }
        .x-audio-wrap {
            transform: rotateY(180deg);
        }
        .x-sector {
            border-right: 2px solid white;
            border-top: 2px solid white;
            .x-dot {
                background: white;
            }
        }
        .x-sector::before {
            border-right: 2px solid white;
            border-top: 2px solid white;
        }
        .x-sector::after {
            border-right: 2px solid white;
            border-top: 2px solid white;
        }
        .x-time {
            transform: rotateY(-180deg);
            color:white;
        }
    }
}

.x-sector.play{
    -webkit-animation:play-sector .3s ease-in-out .1s;
    animation:play-sector .3s ease-in-out .1s;
}
.x-sector.play:before {
    -webkit-animation:play-sector .3s ease-in-out .2s;
    animation:play-sector .3s ease-in-out .2s;
}
.x-sector.play:after {
    -webkit-animation:play-sector .3s ease-in-out .3s;
    animation:play-sector .3s ease-in-out .3s;
}
.x-sector.play .x-dot {
    -webkit-animation:play-dot .3s ease-in-out;
    animation:play-dot .3s ease-in-out;
}
</style>